<template>
    <div v-if="anonymizationRequests.length" class="card">
        <h4 class="card__title">Projekt som väntar på attestering</h4>

        <table class="table">
            <thead>
                <tr>
                    <th>Projektnamn</th>
                    <th class="text-right">Adresser</th>
                    <th>Anonymisering begärd av</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                <tr v-for="anonymizationRequest in anonymizationRequests" :key="anonymizationRequest.id">
                    <td>
                        <a :href="getProjectUrl(anonymizationRequest.model)">{{ anonymizationRequest.model.name }}</a>
                    </td>
                    <td class="text-right">
                        {{ anonymizationRequest.model.addresses_count }}
                    </td>
                    <td>
                        {{ anonymizationRequest.requested_by_user ? anonymizationRequest.requested_by_user.name : '' }}
                    </td>
                    <td class="text-right">
                        <delete-anonymization-request-button
                            :anonymization-request="anonymizationRequest"
                            size="small"
                            class="mr-lg"
                            @deleted="updateAnonymizationRequests"
                        >
                            Neka
                        </delete-anonymization-request-button>

                        <approve-anonymization-request-button
                            :anonymization-request="anonymizationRequest"
                            @approved="updateAnonymizationRequests"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import ApproveAnonymizationRequestButton from './Buttons/ApproveAnonymizationRequestButton';
    import DeleteAnonymizationRequestButton from './Buttons/DeleteAnonymizationRequestButton';

    export default {
        components: {
            ApproveAnonymizationRequestButton,
            DeleteAnonymizationRequestButton,
        },
        props: {
            initialAnonymizationRequests: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                anonymizationRequests: this.initialAnonymizationRequests,
            };
        },

        methods: {
            getProjectUrl(project) {
                return route('admin.sales-projects.show', project);
            },

            updateAnonymizationRequests() {
                axios.get(route('api.gdpr.anonymization-requests.for-projects'))
                    .then(({ data }) => {
                        this.anonymizationRequests = data;
                    });
            },
        },
    };
</script>
